import ApiService from './ApiService';

export default class GeneralApi extends ApiService {
    getAdministrativeUnit() {
        return this.get('administrative-unit');
    }

    getPlaceAutoComplete(payload) {
        return this.get('place-autocomplete', payload);
    }
}
